import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getUserVideoProgress, getLocalStorageData } from '../../utils/localCache.util';
import { VIDEO_TYPES } from '../../config/const.config';
import Loading from './Loading';
import Player from './Player';
import { getMenuDetails, searchData } from '../../services/channelData.service';

const FeaturedPlayerWrapper = ({ activePage, activeSubPage = null }) => {
    const { videoTitle } = useParams();
    const [detailData, setDetailData] = useState(null);
    const [errorRedirect, setErrorRedirect] = useState(false);
    const [currentProgress, setCurrentProgress] = useState(0);
    const [subPage, setSubPage] = useState("");

    const handlePlayerClose = () => {
        const myProgress = getUserVideoProgress(detailData.id);
        const page_url = activePage ? activePage : localStorage.getItem('pageClick');
        if (myProgress > 0) {
            setCurrentProgress(Math.ceil(Number(myProgress)));
        } else {
            setCurrentProgress(0);
        }
        window.location.href = `/${page_url}/${subPage}/${detailData.title.replace(/\s+/g, '_').toLowerCase()}`;
    };

    useEffect(() => {
        const fetchData = async () => {
            const playlistId = getLocalStorageData('pageClick');
            try {
                const response = await searchData(videoTitle);
                let rawVideos = [];
                if (!response || !response.content || !(response.content.videos || response.content.movies || response.content.events)) {
                    rawVideos = response.content.series;
                } else {
                    rawVideos = response.content.videos || response.content.movies || response.content.events || [];
                }
                const menuData = await getMenuDetails(playlistId);
                const matchingPlaylist = menuData?.content?.playlists?.find(
                    (playlist) => String(playlist._id) === String(rawVideos[0].playlist_id)
                );
                const program_type = matchingPlaylist?.program_type ?? 'videos';
                
                const formattedVideos = rawVideos.map((v) => ({
                    id: v._id,
                    playlist_id: v.playlist_id,
                    title: v.title,
                    description: v.description || '',
                    shortDescription: v.short_description || '',
                    hlsUrl: v.hls_url,
                    poster: v.poster,
                    posterH: v.poster_16_9,
                    posterV: v.poster_9_16,
                    startTime: v.start_date_time || '',
                    endTime: v.end_date_time || '',
                    duration: Number(v.duration || 0),
                    genres: v.genres || '',
                    category: v.category || '',
                    channelId: Number(v.channel_id),
                    director: v.director || '',
                    actor1: v.actor1 || '',
                    actor2: v.actor2 || '',
                    actor3: v.actor3 || '',
                    rating: v.rating || '',
                    ratingSource: v.rating_source || '',
                    releaseDate: v.releaseDate || '',
                    season: Number(v.season || 0),
                    episode: Number(v.episode || 0),
                    srtUrl: v.srt_url || '',
                    vttUrl: v.vtt_url || '',
                    source: v.source || '',
                    playDirectUrl: v.playDirectUrl || '',
                    liveVastUrl: v.liveVastUrl || '',
                    type: program_type,
                    isPortrait: program_type === VIDEO_TYPES.MOVIES,
                    ppc_spotlight_active: v?.ppc_spotlight[0]?.ppc_spotlight_active,
                    background_image_video: v?.ppc_spotlight[0]?.background_image_video,
                    ppc_background_image: v?.ppc_spotlight[0]?.background_url,
                    background_video_url: v?.ppc_spotlight[0]?.background_video_url,
                    ppc_dark_overlay: v?.ppc_spotlight[0]?.ppc_dark_overlay,
                    ppc_watch_now_url: v?.ppc_spotlight[0]?.ppc_watch_now_url,
                    ppc_trailer_url: v?.ppc_spotlight[0]?.ppc_trailer_url,
                }));
                setSubPage(formattedVideos[0].playlist_id)
                setDetailData(formattedVideos[0]);
                const myProgress = getUserVideoProgress(formattedVideos[0].id);
                setCurrentProgress(myProgress);
            } catch (error) {
                console.error('Error fetching detail data:', error);
                setErrorRedirect(true);
            }
        };
        fetchData();
    }, [videoTitle]);

    if (!detailData) {
        return <Loading showVideo={false} />;
    }
    if (errorRedirect) return <Navigate to="/" replace />;

    return (
        <Player
            id="player"
            videoData={detailData}
            resumeFrom={currentProgress ? currentProgress : 0}
            handlePlayerClose={handlePlayerClose}
        />
    );
};

export default FeaturedPlayerWrapper;
